import { JSX } from 'solid-js';

type FlexContainerProps = {
    justifyContent?: 'start' | 'end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
    alignItems?: 'stretch' | 'center' | 'start' | 'end';
    gap?: string;
    columnGap?: string;
    rowGap?: string;
    children?: JSX.Element;
    class?: string;
    style?: JSX.CSSProperties;
};

interface FlexRowProps extends FlexContainerProps {
    flexWrap?: 'wrap';
}

export const FlexRow = (props: FlexRowProps) => (
    <div
        class={props.class}
        style={{
            display: 'flex',
            'flex-direction': 'row',
            'align-items': props.alignItems ?? 'center',
            ...(props.gap ? { gap: props.gap } : {}),
            ...(props.columnGap ? { 'column-gap': props.columnGap } : {}),
            ...(props.rowGap ? { 'row-gap': props.rowGap } : {}),
            ...(props.flexWrap ? { 'flex-wrap': props.flexWrap } : {}),
            ...(props.justifyContent ? { 'justify-content': props.justifyContent } : {}),
            ...(props.style || {}),
        }}
    >
        {props.children}
    </div>
);

export const FlexColumn = (props: FlexContainerProps) => (
    <div
        class={props.class}
        style={{
            display: 'flex',
            'flex-direction': 'column',
            ...(props.justifyContent ? { 'justify-content': props.justifyContent } : {}),
            ...(props.alignItems ? { 'align-items': props.alignItems } : {}),
            ...(props.gap ? { gap: props.gap } : {}),
            ...(props.columnGap ? { 'column-gap': props.columnGap } : {}),
            ...(props.rowGap ? { 'row-gap': props.rowGap } : {}),
            ...(props.style || {}),
        }}
    >
        {props.children}
    </div>
);
